export default __webpack_public_path__ + "static/media/checkverde.072b11e2.svg";